module.exports = __webpack_public_path__ + "img/grey-information-circle.81ccfdbe.svg";